import { render, staticRenderFns } from "./MilestoneList.vue?vue&type=template&id=438cf632&scoped=true"
import script from "./MilestoneList.vue?vue&type=script&lang=js"
export * from "./MilestoneList.vue?vue&type=script&lang=js"
import style0 from "./MilestoneList.vue?vue&type=style&index=0&id=438cf632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438cf632",
  null
  
)

export default component.exports